import { useMemo, useState } from "react";
import { useSearchParams } from "react-router";
import { VStack } from "@astryxdesign/core/VStack";
import { HStack } from "@astryxdesign/core/Stack";
import { Screen } from "@/components/layout/Screen";
import { GlassSwitch } from "@/components/layout/GlassSwitch";
import { Empty } from "@/components/states";
import { useStudio } from "@/features/studio/StudioRoot";
import { useBookingNav } from "@/features/booking/useBookingNav";
import { ServiceList } from "./ServiceList";
import { useT } from "@/lib/i18n";

export function ServicesScreen() {
  const studio = useStudio();
  const t = useT();
  const nav = useBookingNav();
  const categories = useMemo(() => [...new Set(studio.services.map((s) => s.category).filter(Boolean))], [studio.services]);
  const [params] = useSearchParams();
  const [category, setCategory] = useState(() => params.get("c") ?? "all");
  const shown = category === "all" ? studio.services : studio.services.filter((s) => s.category === category);

  return (
    <Screen title={t.services.title}>
      {categories.length > 1 ? (
        <HStack isScrollable paddingBlock={3} paddingInline={1} className="no-scrollbar">
          <GlassSwitch
            label={t.services.category}
            value={category}
            onChange={setCategory}
            size="sm"
            fill={false}
            options={[{ value: "all", label: t.services.all }, ...categories.map((c) => ({ value: c, label: c }))]}
          />
        </HStack>
      ) : null}
      <VStack gap={2}>
        {shown.length ? (
          <ServiceList studio={studio} services={shown} onPick={(s) => nav.open(s.id)} />
        ) : (
          <Empty title={t.services.emptyCategory} />
        )}
      </VStack>
    </Screen>
  );
}
